module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ;  var sufferer = Util.clone(value); 
    ; __append("\n")
    ;  if (sufferer.removed) { 
    ; __append("\n\n<b>УДАЛЁН</b>\n\n")
    ;  } else { 
    ; __append("\n")
    ;  if (Util.isDefined(sufferer.type) && sufferer.type != Glonass.SuffererType.Unknown) { 
    ; __append("\n<div>\n	<b>")
    ; __append(escapeFn( Glonass.SuffererType.title(sufferer.type) ))
    ; __append("</b>\n</div>\n")
    ;  } 
    ; __append("\n")
    ;  if (sufferer.person) { 
    ; __append("\n<div>\n	")
    ; __append( card.render("Person", { value: sufferer.person, mode: mode }) )
    ; __append("\n</div>\n")
    ;  } 
    ; __append("\n")
    ;  if (sufferer.address) { 
    ; __append("\n<div>\n	<b>Адрес:</b>\n	")
    ; __append( card.render("Address", { value: sufferer.address, mode: mode }) )
    ; __append("\n</div>\n")
    ;  } 
    ; __append("\n\n")
    ;  if (sufferer.medicineiclintegrationcall) { 
    ; __append("\n")
    ; __append( UI.Template.render("Medicine/Integration/ICL/Voucher/Info", { sufferer: sufferer, data: sufferer.medicineiclintegrationcall, card: card }) )
    ; __append("\n")
    ;  } 
    ; __append("\n")
    ;  } 
    ; __append("\n")
  }
  return __output.join("");

}